import { render } from "./TabThirds.vue?vue&type=template&id=19904503"
import script from "./TabThirds.vue?vue&type=script&lang=js"
export * from "./TabThirds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__